import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { FacebookIcon } from './SocialIcons/FacebookIcon';
import { InstagramIcon } from './SocialIcons/InstagramIcon';
import { LinkedinIcon } from './SocialIcons/LinkedinIcon';
import { XTwitterIcon } from './SocialIcons/XTwitterIcon';
import { YoutubeIcon } from './SocialIcons/YoutubeIcon';
import {
  YOUTUBE_LINK,
  XTWITTER_LINK,
  LINKEDIN_LINK,
  INSTAGRAM_LINK,
  FACEBOOK_LINK,
} from 'constants/pageLinks';

const IconWrapper = ({
  children,
  fill,
  borderColor,
  borderRadius,
  bgHoverColor,
}: {
  children: ReactNode;
  fill: string;
  bgHoverColor: string;
  borderColor?: string;
  borderRadius?: string;
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: `1px solid ${borderColor || fill}`,
      width: { xs: '40px', sm: '32px' },
      height: { xs: '40px', sm: '32px' },
      p: (theme) => ({ xs: theme.spacing(0.5), sm: theme.spacing(0.25) }),
      borderRadius: (theme) => borderRadius || theme.spacing(0.5),

      ':hover': {
        bgcolor: bgHoverColor,
      },
    }}
  >
    {children}
  </Box>
);

const SocialIcons = () => {
  const fill = '#39A949';
  const borderColor = '#39A949';
  const borderRadius = '4px';
  const bgHoverColor = '#E6F9E6'; // Light green background on hover

  const socialIconsData = [
    {
      label: 'Youtube',
      href: YOUTUBE_LINK,
      icon: <YoutubeIcon fill={fill} />,
    },
    {
      label: 'LinkedIn',
      href: LINKEDIN_LINK,
      icon: <LinkedinIcon fill={fill} />,
    },
    {
      label: 'Instagram',
      href: INSTAGRAM_LINK,
      icon: <InstagramIcon fill={fill} />,
    },
    {
      label: 'Facebook',
      href: FACEBOOK_LINK,
      icon: <FacebookIcon fill={fill} />,
    },
    { label: 'X', href: XTWITTER_LINK, icon: <XTwitterIcon fill={fill} /> },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: (theme) => theme.spacing(2),
      }}
    >
      {socialIconsData.map(({ label, href, icon }) => (
        <Link
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${label} icon`}
        >
          <IconWrapper
            borderColor={borderColor}
            fill={fill}
            borderRadius={borderRadius}
            bgHoverColor={bgHoverColor}
          >
            {icon}
          </IconWrapper>
        </Link>
      ))}
    </Box>
  );
};
export { SocialIcons };
